<template>
  <a-modal v-model="visible" :title="title" :destroyOnClose="true" :width="'90%'">
    <a-form-model ref="planForm" :model="plan" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="4">
          <a-form-model-item label="Name" prop="name">
            <a-input placeholder="Name" v-model="plan.name" />
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item label="Business" prop="businessId">
            <a-select
              placeholder="Business"
              v-model="plan.businessId"
              style="width: 100%"
            >
              <a-select-option
                v-for="business in businesses"
                :key="business.id"
                :value="business.id"
              >
                {{ business.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item label="Storage Size (GB)" prop="storageSize">
            <a-input-number
              class="width-100"
              placeholder="Storage Size"
              :min="1"
              v-model="plan.storageSize"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item label="Price" prop="price">
            <a-input-number
              class="width-100"
              placeholder="Price"
              :min="1"
              v-model="plan.price"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="4">
          <a-form-model-item label="Subtitle" prop="subtitle">
            <a-input
              class="width-100"
              placeholder="Subtitle"
              :min="1"
              v-model="plan.subtitle"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="2">
          <a-form-model-item label="Charge Cycle" prop="chargeCycle">
            <a-select
              v-model="plan.chargeCycle"
              placeholder="Charge Cycle"
              style="width: 100%"
            >
              <a-select-option
                v-for="cycle in chargeCycles"
                :key="cycle.id"
                :value="cycle.id"
              >
                {{ cycle.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="2">
          <a-form-model-item label="Is Active" prop="isActive">
            <a-switch v-model="plan.isActive" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row  :gutter="16">
        <a-col :span="24">
          <a-form-model-item label="Description" prop="description">
            <!-- <a-textarea class="width-100" placeholder="Description" :min="1" v-model="plan.description" /> -->

            <editor
              api-key="lriv06w5l8uywsudqf3xk1fyeptapcz5wwhbz8iwlywuzhm9"
              :init="{
                height: '400',
                menubar: false,
                placeholder: 'Description',
                plugins: [
                  'print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor insertdatetime advlist lists wordcount textpattern noneditable help charmap quickbars emoticons',
                ],
                toolbar:
                  'undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl |',
              }"
              v-model="plan.description"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <a-button type="primary" @click="save" :loading="isSaving">{{
        actionButtonText
      }}</a-button>
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>
<script>
import { plansMutations } from "../../Store/store";
import Editor from "@tinymce/tinymce-vue";

export default {
  props: {
    value: Boolean,
    mode: String,
    plan: {
      type: Object,
      defualt: () => ({}),
    },
    businesses: Array,
    chargeCycles: Array,
  },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "Please input Plan Name",
            trigger: "blur",
          },
        ],
        storageSize: [
          {
            required: true,
            message: "Please input Storage Size",
            trigger: "blur",
          },
        ],
        price: [
          { required: true, message: "Please input Price", trigger: "blur" },
        ],
        chargeCycle: [
          {
            required: true,
            message: "Please pick a Charge Cycle",
            trigger: "change",
          },
        ],
        businessId: [
          {
            required: true,
            message: "Please pick a Business",
            trigger: "change",
          },
        ],
      },
      isSaving: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    title() {
      return this.mode == "create" ? "New Plan" : "Edit plan";
    },
    actionButtonText() {
      return this.mode == "create" ? "Save" : "Update";
    },
  },
  methods: {
    cancel() {
      this.visible = false;
    },
    save() {
      this.$refs.planForm.validate(async (valid) => {
        if (valid) {
          this.isSaving = true;

          var changedPlan = {
            id: this.plan.id,
            name: this.plan.name,
            storageSize: this.plan.storageSize,
            price: this.plan.price,
            chargeCycle: this.plan.chargeCycle,
            businessId: this.plan.businessId,
            isActive: this.plan.isActive,
            subtitle: this.plan.subtitle,
            description: this.plan.description,
          };

          try {
            if (this.mode == "create") {
              await plansMutations.addPlan(changedPlan);
            } else {
              await plansMutations.updatePlan(changedPlan);
            }
            this.visible = false;
          } catch (error) {
            this.showError(error);
          } finally {
            this.isSaving = false;
          }
        }
      });
    },
  },
  components: {
    editor: Editor,
  },
};
</script>

<style></style>